import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { getFunctions, httpsCallable } from "firebase/functions";
import { from } from "rxjs";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { RequestBodyService } from "src/app/services/request-body.service";
import { RequestPaymentService } from "src/app/services/RequestBodyService/RequestPayment/request-payment.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-request-confirmation",
    templateUrl: "./request-confirmation.component.html",
    styleUrls: ["./request-confirmation.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class RequestConfirmationComponent {
  UserID: string;
  userData: Data;
  selectedLanguage: string;
  public userId: string;
  constructor(
    private dialogRef: MatDialogRef<RequestConfirmationComponent>,
    private requestBodyService: RequestBodyService,
    private http: HttpClient,
    private authService: AuthService,
    private accountService: AccountRepositoryService,
    public translate: TranslateService,
    private router: Router,
    private RequestPaymentService: RequestPaymentService
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    // This method is used to get the user id from local storage
    // this.UserID = this.userId;
    // This method is used to get the user data
    this.authService?.userDetails$?.subscribe(
      (user: Data) => {
        try {
          this.userData = user;
        } catch (err) {
          // Error handling
          throw new Error(`User details not found ${err}`);
        }
      }
    );
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("RequestConfirmationComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.UserID = this.userId;
      })
      .catch((error) => {
        return error;
      });
  }
  // This method is used to back to account
  public BackToAccount() {
    this.gdprRequest();// This method has been used to send the GDPR request
    this.slackRequestMsg();// This method has been used to send slack message
    this.accountService.dismissAll("legal");
    this.router.navigateByUrl("/mainTabs/tabs/home");
    const threeSeconds = 3000;
    setTimeout(() => {
      // Dealy for 3 mins to display this toast after reach home page.
      this.authService
        .getConstantsMsg("1147")
        .then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "We'll send the information requested to the email in your account within 30 days",
              line_2: "",
            },
            style: {
              icon: "tick circle success.png",
              type: "Success",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
    }, threeSeconds);
    this.dialogRef.close(); // This method is used tclose the dialog
  }
  // This method is used to close the dialog
  close() {
    this.dialogRef.close();
  }
  // Tbis method is used to send the GDPR request
  public gdprRequest() {
    const request = this.RequestPaymentService?.insertGdprRequest(this.UserID);
    const functions = getFunctions();
    functions.region = AuthService.FIREBASE_REGION;
    const api = httpsCallable(functions, "apiv2");
    return from(api(request))
  }
  // This method is used to send slack message
  public slackRequestMsg() {
    if (this.userData !== null && this.userData !== undefined) {
      this.authService
        .getV2CloudFunction("sendslackmessage", {
          msn: this.userData?.msn,
          userid: this.userId,
          email: this.userData?.email,
        })
        .subscribe();
    }
  }
}
